import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

/**
 * This component will display a loading message and then redirect to a PDF url.
 * It uses the React Router's useParams hook to get the :orderId path value.
 */
const PdfViewer = (props) => {
	const { orderId } = useParams();
	useEffect(() => {
		fetch().then(() => {
			window.location.href = `${process.env.REACT_APP_GEAR_REST_URL}/packing-slip/customize/order/${orderId}`;
		});
	}, [orderId]);

	// If children were passed in, use that while loading the PDF. Otherwise, use default loading content.
	return (
		props.children || (
			<div className="loading-shield-opaque">
				<i className="fa fa-spinner fa-spin fa-fw loading-icon"></i>
				<h2 style={{ top: '30%', position: 'relative', left: '1.5em' }}>Building Requisition</h2>
			</div>
		)
	);
};

export default PdfViewer;
